// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1tcWA","content":"ManualTimeModal_content__flXTs"};